export const GET_PRODUCT_UNIT_BY_PRODUCT_ID_REQUEST =
  "get_product_unit_by_product_id_request";
export const GET_PRODUCT_UNIT_BY_PRODUCT_ID_RESPONSE =
  "get_product_unit_by_product_id_response";

export const GET_PRODUCT_UNIT_TYPE_REQUEST = "get_product_unit_type_request";
export const GET_PRODUCT_UNIT_TYPE_RESPONSE = "get_product_unit_type_response";

export const ADD_PRODUCT_UNIT_REQUEST = "add_product_unit_request";
export const ADD_PRODUCT_UNIT_RESPONSE = "add_product_unit_response";

export const UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST =
  "update_product_unit_by_product_unit_id_request";
export const UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE =
  "update_product_unit_by_product_unit_id_response";

export const DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST =
  "delete_product_unit_by_product_unit_id_request";
export const DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_RESPONSE =
  "delete_product_unit_by_product_unit_id_response";

export const UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_REQUEST =
  "update_product_unit_status_by_product_unit_id_request";
export const UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_RESPONSE =
  "update_product_unit_status_by_product_unit_id_response";
